import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';

import { GenericValue, HisUiService, HisBaseGlobalsService, HisNotificationService } from 'hisng';
import { GlobalIdentifier } from '../../model/global-identifier';

import { GlobalIdentifierTypeService } from '../../service/types.service';

@Component( {
    selector: 'res-identifier-dialog',
    templateUrl: './identifier-dialog.component.html',
} )
export class IdentifierDialogComponent implements OnInit {
    @Input() globalIdentifier: GlobalIdentifier;
    @Input() globalIdentifierHiskeyId: string;
    @Input() context: string;
    @Input() visibility: boolean;
    @Output() visibilityChange: EventEmitter<boolean> = new EventEmitter();
    @Output() globalIdentifierChange: EventEmitter<GlobalIdentifier> = new EventEmitter();

    public identifierOptions: GenericValue[];
    public filteredIdentifiers: GenericValue[];

    constructor( private hisUiService: HisUiService,
        private hisBaseGlobalsService: HisBaseGlobalsService,
        private notificationService: HisNotificationService,
        private globalIdentifierTypeService: GlobalIdentifierTypeService ) { }

    ngOnInit() {
        this.globalIdentifierTypeService.getGlobalIdentifierValuesByEntity( this.context ).subscribe(
            ( globalIdentifierValues: GenericValue[] ) => {
                this.identifierOptions = globalIdentifierValues;
            } );
    }

    public filterIdentifiers( event: { query: string } ) {
        this.filteredIdentifiers = [];
        this.identifierOptions.forEach( identifier => {
            if ( identifier.text.toLowerCase().indexOf( event.query.toLowerCase() ) === 0 ) {
                this.filteredIdentifiers.push( identifier );
            }
        } );
    }

    /* close dialog action */
    public closeDialog() {
        this.visibilityChange.emit(false);
    }

    public applyChanges() {
        let messages = this.getValidationMessages();
        if ( messages.length !== 0 ) {
            this.notificationService.error(
                messages,
                this.hisUiService.translate('global.validationerror')
            );
        } else {
            this.globalIdentifierChange.emit(this.globalIdentifier);
            this.closeDialog();
        }
    }

    private getValidationMessages() {
        let messages: any[] = [];
        let inputRequired = this.hisUiService.translate('validation.required');
        let ddKeyRequiredType =
            this.hisBaseGlobalsService.getDd('fs.res.publication.GlobalIdentifier.globalIdentifierType');
        let ddKeyRequiredValue = this.hisBaseGlobalsService.getDd('fs.res.publication.GlobalIdentifier.identifier');

        if ( ddKeyRequiredType.required && !this.globalIdentifier.globalIdentifierType ) {
            messages.push(`${this.hisUiService.translate(
                'fs.res.publication.GlobalIdentifier.globalIdentifierType')}: ${inputRequired}`);
        }
        if ( ddKeyRequiredValue.required && !this.globalIdentifier.identifier ) {
            messages.push(`${this.hisUiService.translate(
                'fs.res.publication.GlobalIdentifier.identifier')}: ${inputRequired}`);
        }
        return messages;
    }
}
